import {useEffect, useState} from "react";
import { axiosRequestData } from "../helpers/axios";
import {iGolfCourse} from "../interfaces/iGolfCourse";
import {iGolfCourseTee} from "../interfaces/iGolfCourseTee";

const postData = {
  active: "1",
  page: "1",
  resultsPerPage: "100",
  countryFormat: "4",
  stateFormat: "4"
};

export const UseiGolfData = () => {
  const [courseList, setCourseList] = useState<any[]>([]);
  const [selectedCourse, setSelectedCourse] = useState<iGolfCourse | null>(null);
  const [loading, setLoading] = useState(false);

  const searchiGolfCourses = async (courseName: string, stateList: any[]) => {
    if (selectedCourse) {
        return;
    }

    setLoading(true);
    setCourseList([]);

    const words = courseName.includes(",") ? courseName.split(",") : null;
    const multipleParam = words ? words.pop()?.trim() : null;
    const coursesMerged: any = [];

    const fetchCourses = async (url: string, data: any, coursesMerged: any[]) => {
        const response = await axiosRequestData("POST", url, data);
        if (response.data.code === 'success' && response.data.data.Status === 1) {
            coursesMerged.push(...response.data.data.courseList);
        }
    };

    const removeDuplicatesById = (array: any) =>  {
        return array.filter((item: any, index: any, self: any) =>
            index === self.findIndex((t: any) => t.id_course === item.id_course)
        );
    }

    if ((courseName.trim().split(/\s+/).length > 1 || courseName.includes(',')) && multipleParam) {
        const courseNameTmp = courseName?.replace(multipleParam, "").replace(",", "").trim();

        const stateFound = stateList.find((state) =>
            multipleParam.length > 2
                ? state.stateFull.toLowerCase().includes(multipleParam.toLowerCase())
                : state.stateShort === multipleParam.toUpperCase()
        );

        if (stateFound) {
            await fetchCourses("/wp-json/pg/v2/sc/igolf",
                { ...postData, courseName: courseNameTmp, id_state: stateFound.id_state },
                coursesMerged
            );

            await fetchCourses("/wp-json/pg/v2/sc/igolf",
                { ...postData, courseName: courseNameTmp },
                coursesMerged
            );
        } else if (multipleParam.length >= 4) {
            await fetchCourses("/wp-json/pg/v2/sc/igolf",
                { ...postData, courseName: courseNameTmp, city: multipleParam },
                coursesMerged
            );

            await fetchCourses("/wp-json/pg/v2/sc/igolf",
                { ...postData, courseName: courseNameTmp },
                coursesMerged
            );
        }
    }

    await fetchCourses("/wp-json/pg/v2/sc/igolf",
        { ...postData, courseName: courseName },
        coursesMerged
    );

    const uniqueCourses = removeDuplicatesById(coursesMerged);

    setCourseList(uniqueCourses);

    setLoading(false);
  };
  
  return { courseList, setCourseList, searchiGolfCourses, setSelectedCourse, selectedCourse, loadingiGolf: loading };
};

export const UseiGolfCourseTeeDetails = () => {
    const [teeDetails, setTeeDetails] = useState<iGolfCourseTee[]>([]);
    const [loading, setLoading] = useState(false);
    const [gender, setGender] = useState<string>("Men");
    const [selectedTee, setSelectedTee] = useState<iGolfCourseTee | null>(null);

    const getTeeDetailsText = (tee: iGolfCourseTee): string => {
        //FORMAT TEE: teeColorName totalYards yds (Slope/CourseRating)
        //totalYards = yds1to9 + yds10to18

        return `${tee.teeColorName} ${tee.yds1to9 + tee.yds10to18} yds (${tee.slope}/${tee.courseRating})`;
    }

    useEffect(() => {
        const localGender = localStorage.getItem('iGolfGender');
        if (localGender) {
            setGender(localGender);
        }
    }, []);

    useEffect(function setGenderTeeList()  {
        if (teeDetails.length > 0) {
            setLoading(true);
            const teeGanderUpdated = updatedTeeListByGender(teeDetails);
            setTeeDetails(teeGanderUpdated);
            setLoading(false);
        }
    }, [gender]);

    const updatedTeeListByGender = (teeList: iGolfCourseTee[])=> {
        return teeList.map((tee: iGolfCourseTee) => {
            const isMen = gender.toLowerCase() === 'men';
            const isWomen = gender.toLowerCase() === 'women';

            return {
                ...tee,
                gender: gender.toLowerCase(),
                slope: isMen ? tee.slopeMen || 0 : isWomen ? tee.slopeWomen || 0 : tee.slope,
                courseRating: isMen ? tee.ratingMen || 0 : isWomen ? tee.ratingWomen || 0 : tee.courseRating,
            };
        });
    }
    const getTeeDetails = async (courseId: string) => {
        setLoading(true);

        await axiosRequestData("POST", "/wp-json/pg/v2/sc/igolf/tee", {
            detailLevel: "2",
            id_course: courseId
        }).then((response) => {
            if (response.data.code === 'success') {
                const teeListData = updatedTeeListByGender(response.data.data.teesList);
                setTeeDetails(teeListData);
            }
        }).catch(error => console.error(`Error: ${error}`))
        .finally(() => setLoading(false));
    };

    return { teeDetails, setTeeDetails, getTeeDetails, loadingTee: loading, selectedTee, setSelectedTee, gender, setGender, getTeeDetailsText };
};

export const UseiGolfGetStates = () => {
  const [countryStateList, setCountryStateList] = useState<any[]>([]);

  const countryList = [
    840,  // USA 🇺🇸
    826,  // UK (England) 🇬🇧
    124, // Canada 🇨🇦
    392,  // Japan 🇯🇵
    410,  // South Korea 🇰🇷
    36,   // Australia 🇦🇺
  ];

  const getStateListByCountries = async () => {
    //TODO: call only once
    const cachedStates = localStorage.getItem("iGolfStates");

    if (cachedStates) {
      setCountryStateList(JSON.parse(cachedStates));
    } else {
      try {
        const promises = countryList.map((indexCountry) =>
            axiosRequestData("POST", "/wp-json/pg/v2/sc/igolf/statelist", {
              id_country: indexCountry,
            })
        );

        const responses = await Promise.all(promises);

        const stateResult = responses
            .filter(
                (response) =>
                    response.data.code === "success" &&
                    response.data.data.Status === 1
            )
            .flatMap((response) => response.data.data.stateList);

        setCountryStateList(stateResult);
        localStorage.setItem("iGolfStates", JSON.stringify(stateResult));
      } catch (error) {
        console.error(`Error: ${error}`);
      }
    }
  }

  return {countryStateList, getStateListByCountries};
}
